import Cleave from "cleave.js/react";
//-----------------------------------------------------
import Modal from "src/components/common/modal";
import { myAccessOptions } from "./userForm";
//-----------------------------------------------------
export default function UserForm({
    email, shouldDisable, firstName, middleName, lastName, phoneNumber, background, 
    postUrl, keyword, handleSubmit, closeIt
}){
    //-----------------------------------------------------
    return(
        <Modal 
            closeIt = {closeIt}
            title = {keyword}
            width = {"1400px"}
            handleFormSubmit = {handleSubmit}
            actionKey = {keyword}
        >
            {Object.entries(myAccessOptions).map(([key, value], index) => 
                <input
                key = {index}
                className = "nodisplay"
                type = "text"
                readOnly
                name = {key}
                value = {key === "workLogs"?"yes":value[0]}
            />
            )}
            <input
                className = "nodisplay"
                type = "text"
                readOnly
                name = "dispatch"
                value = {"1"}
            />
            <input
                className = "nodisplay"
                type = "text"
                readOnly
                name = "url"
                value = {postUrl}
            />
            <div className = "my-2" style = {{display:"flex"}}>
                <span className = "font-weight-bold mr-3 py-2 required-field">Email:</span>
                <input required className = "form-control" type = "email" style = {{flexGrow: 1, textTransform: "lowercase"}} name = "userEmail" readOnly = {shouldDisable} defaultValue = {email}/>
            </div>
            <div className = "my-2" style = {{display:"flex"}}>
                <span className = "font-weight-bold mr-3 py-2">Name:</span>
                <input required placeholder = "First Name" className = "form-control mr-3" style = {{flexGrow: 1}} name = "firstName" defaultValue = {firstName || ""}/>
                <input placeholder = "Middle Name" className = "form-control mr-3" style = {{flexGrow: 1}} name = "middleName" defaultValue = {middleName || ""}/>
                <input required placeholder = "Last Name" className = "form-control" style = {{flexGrow: 1}} name = "lastName" defaultValue = {lastName || ""}/>
            </div>
            <div className = "my-2" style = {{display:"flex"}}>
                <span className = "font-weight-bold mr-3 py-2">Phone:</span>
                <Cleave
                        required
                    placeholder = "Mobile Phone"
                    pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^"
                    className = "form-control mr-3" style = {{flexGrow: 1}} name = "phoneNumber" value = {phoneNumber || ""}
                    options = {{
                        blocks:[3, 3, 4],
                        delimiter: "-",
                        numericOnly: true,
                    }}
                />
            </div>
            <div className = "my-2" style = {{display:"flex", alignItems: "center"}}>
                <div className = "font-weight-bold mr-3">Background:</div>
                <textarea className = "form-control" name = "background" style = {{width: "100%", height: "100%"}} defaultValue = {background}/>
            </div>
        </Modal>
    )
}